import styled from 'vue-styled-components'

export default styled.div`
    .tariff-value-container {
        display: flex;
    }
`;